import { IndustryPage } from './IndustryPage'
import { industriesData } from '@/data/industries'

export default function Consulting() {
  return <IndustryPage industry={industriesData.consulting!} />
}
